import { track, PageSource } from '@mc/track-event'
import { hasActiveAnnualMembership } from '@mc/user-info'

type PageSourceType =
  | typeof PageSource.MAW_HOME
  | typeof PageSource.MAW_ACCELERATOR
  | typeof PageSource.MAW_COLLECTIVE

type TrackConnectClickProps = {
  location:
    | 'homepage-connect-with-us'
    | 'collective-hero'
    | 'collective-holistic-skills'
    | 'collective-connect-with-us'
    | 'accelerator-hero'
    | 'accelerator-holistic-skills'
    | 'accelerator-connect-with-us'
  pageSource: PageSourceType
}

export const trackConnectClick = ({
  location,
  pageSource,
}: TrackConnectClickProps) =>
  track('Enterprise Connect With Us Clicked', {
    location,
    post_paywall: hasActiveAnnualMembership(),
    page_source: pageSource,
  })

type TrackLearnMoreClickProps = {
  action: 'collective' | 'accelerator'
}

export const trackLearnMoreClicked = ({ action }: TrackLearnMoreClickProps) =>
  track('Enterprise Learn More Clicked', {
    location: 'learn-more-section',
    action,
    post_paywall: hasActiveAnnualMembership(),
    page_source: PageSource.MAW_HOME,
  })

type TrackContactUsClickProps = {
  pageSource: PageSourceType
}

export const trackEnterpriseContactUsClicked = ({
  pageSource,
}: TrackContactUsClickProps) =>
  track('Enterprise Contact Us Clicked', {
    location: 'contact-us-form',
    post_paywall: hasActiveAnnualMembership(),
    page_source: pageSource,
  })

type TrackHomePageClickProps = {
  action:
    | 'for-learners'
    | 'for-admins'
    | 'for-managers'
    | 'for-employees'
    | 'healthcare'
    | 'professional-services'
    | 'accelerator-for-retail'
    | 'accelerator-for-food-services'
  location: 'how-it-works' | 'success-stories' | 'industry-impact'
  pageSource: PageSourceType
}

export const trackHomePageClick = ({
  action,
  location,
  pageSource,
}: TrackHomePageClickProps) =>
  track('Home Page Click', {
    action,
    location,
    post_paywall: hasActiveAnnualMembership(),
    page_source: pageSource,
  })
